module.exports = __webpack_public_path__ + "static/logo-5ea2d06f4e4201c88db45021b8844a89.png";